import { render } from "./adverts.html?vue&type=template&id=33334cef&external"
import script from "./adverts.js?vue&type=script&lang=js&external"
export * from "./adverts.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__